import React from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import TimeInput from "./TimeInput";
import MonthlyCalendarInput from "./MonthlyCalendarInput";
import MonthlyCalendarJalaliInput from "./MonthlyCalendarJalaliInput";

let moment = require('jalali-moment');
// let moment = require('moment-timezone');

class DateInput extends React.Component {

    state = {
        isOpen: false,

    }



    toggleOpen(open) {
        // console.log("toggleOpen")

        let openState = open != null ? open : !this.state.isOpen

        // document.addEventListener('mousedown', this.closeBox);
        // window.addEventListener('scroll', this.getPosition, true);
        // this.getPosition()
        // if (openState) {
        this.fixedView.showView()
        // } else {
        //     this.fixedView.hideView()
        // }
        this.setState({ isOpen: true })
    }




    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }




    changeDateValue = (key, value, extra) => {

        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }


    render() {

        let info = this.props.header.information
        let variables = this.props.variables

        let format = this.state.time ? 'MMM DD, YYYY HH:mm' : 'MMM DD, YYYY'

        if (variables?.appletSettings?.calendarType == 'jalali') {
            format = this.state.time ? 'jYYYY/jM/jD HH:mm' : 'jYYYY/jM/jD'
        }


        return (
            <>

                <div className='position-relative w-100 h-100 ' ref={ref => this.setWrapperRef(ref)}>
                    <div className="cursor-pointer" ref={el => this.currentNode = el} onClick={() => this.toggleOpen()} disabled={info?.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} defaultValue={this.props.data} placeholder={info?.placeHolder} style={{ height: '100%', color: '#222', display: 'flex', alignItems: 'center' }} >
                        {this.props.data && (<p className=" input-text no-wrap date-text">{this.props.data ? (typeof this.props.data == 'string' && this.props.data.startsWith('{{')) ? this.props.data.replace('{{', '').replace('}}', '') : moment(this.props.data).format(format) : ''}</p>)}
                        {!this.props.data && (<p className="w-100 placeholder" style={{}}>{info?.placeholder != null ? checkTranslation(info?.placeholder) : translate("Select ...")}</p>)}
                    </div>

                    {/* {this.state.isOpen && (
                        <div style={{ position: 'fixed', top: this.state.top, backgroundColor: '#fff', borderRadius: 5, width: '270px', zIndex: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: 10 }}> */}
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={8} bottomOffset={20} zIndex={11} xOffset={0} rightAlign={false} width={info.showVariables ? 410 : 265}>

                        <div style={{ backgroundColor: '#ffffff', borderRadius: 8, zIndex: 5, boxShadow: '0px 0px 50px rgba(0,0,0,0.2)', border: '1px solid #eee', maxWidth: 410, minWidth: 265 }}>

                            {(variables?.appletSettings?.calendarType == 'jalali') ? (
                                <MonthlyCalendarJalaliInput data={this.props.data} header={this.props.header} changeValue={this.changeDateValue} variables={this.props.variables} width={this.props.width} />
                            ) : (
                                <MonthlyCalendarInput data={this.props.data} header={this.props.header} changeValue={this.changeDateValue} variables={this.props.variables} width={this.props.width} />
                            )}






                        </div>
                    </FixedView>
                    {/* )} */}

                </div>

                {/* </div > */}
            </>
        );
    }
}

export default DateInput;
